<template>
  <div class="row col-12">
    <div class="row col-12">
      <q-form ref="adicionarAtividadeForm" class="row col-12">
        <div class="row col-12 q-gutter-x-sm text-brand-5 text-weight-bold">
          <div class="col-md-6 col-xs-12">
            <div class="q-ml-sm titulo-input">Adicionar Encerramento</div>
            <q-input
              dense
              outlined
              v-model="adicionarAtividadeDto.nome"
              :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
            />
          </div>
          <div>
            <q-btn
              class="btn"
              no-caps
              dense
              label="Adicionar Pergunta"
              color="primary"
              icon="add_circle_outline"
              @click="adicionarAtividade"
            />
          </div>
        </div>
      </q-form>
    </div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";

export default {
  props: ["unidadeId"],
  emits: ["closing"],
  setup(props, { emit }) {
    const incluir = ref(false);
    const adicionarAtividadeForm = ref(null);
    const adicionarAtividadeDto = ref({
      nome: "",
    });
    const store = useStore();
    const quasar = useQuasar();

    const adicionarAtividade = async () => {
      const valido = await adicionarAtividadeForm.value.validate();
      if (!valido) {
        return;
      }

      try {
        await store.dispatch("pdt/adicionarEncerramento", {
          unidadeId: props.unidadeId,
          pergunta: adicionarAtividadeDto.value.nome,
        });

        resetForm();
        quasar.notify({
          message: "Pergunta adicionada",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        emit("closing");
      } catch (error) {
        let message = "Ocorreu um erro ao adicionar a atividade";
        if (error.response) {
          message = error.response.data.erros;
        }

        quasar.notify({
          message,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      }
    };

    const resetForm = () => {
      adicionarAtividadeDto.value = {
        nome: "",
        tipo: "atividade",
        critico: false,
      };
      adicionarAtividadeForm.value.reset();
    };

    return {
      incluir,
      adicionarAtividadeForm,
      adicionarAtividadeDto,
      adicionarAtividade,
    };
  },
};
</script>

<style scoped>
.btn {
  margin-top: 24px;
}
@media (max-width: 600px) {
  .btn {
    font-size: 12px;
    margin: 5px 0px 0px 1px;
  }
  .titulo-input {
    margin: 0px 0px 0px 0px;
    font-size: 12px;
  }
}
</style>
